module.exports = __webpack_public_path__ + "img/boc_superrunfund.0bccd02.png";